import { toast } from "react-toastify";
import { useStateValue } from "../context/StateProvider";
import PageHeader from "../components/PageHeader";
import {
  Section,
  subjectForDeal,
  fileRequestLink,
} from "../components/home/PendingInboxPanel";
import { usePendingFileRequests } from "../hooks/usePendingFileRequests";
import { useDealClientNames } from "../hooks/useDealClientNames";
import { completeFileRequest } from "../utils/completeFileRequest";
import { actsAsClientCare } from "../utils/roles";

// The full File Requests queue on its own screen. "View all" on the dashboard
// card lands here. It CANNOT link to the transactions board instead: a file
// request is stored as a soft-deleted deal, and the board hides those — the
// board is a dead end for this queue (see utils/fileRequestQueue.js).
// 2026-08-26, Henry: "it should open to its own screen. with the lsit. not
// transcations."
export default function FileRequestsPage() {
  const [{ user, users }] = useStateValue();
  const role = user?.role;
  const canSee =
    role === "Admin" || role === "Supervisor" || actsAsClientCare(user);

  const { fileRequests, reload } = usePendingFileRequests(canSee);
  const { getClientName } = useDealClientNames(fileRequests);

  if (!canSee) {
    return (
      <div className="px-6 py-16 text-center text-gray-500">
        File requests are handled by Client Care and the Team Lead — this page
        isn't part of your workflow.
      </div>
    );
  }

  const findAgent = (deal) =>
    (users || []).find(
      (u) => u?.id === deal?.agentData || u?.id === deal?.createdby,
    );

  const handleComplete = async (deal) => {
    const res = await completeFileRequest(deal, user, users);
    if (!res.success) {
      toast.error("Could not mark this file completed.");
      return;
    }
    toast.success("File marked completed. Agent notified.");
    await reload();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="File Requests"
        subtitle={
          fileRequests.length === 0
            ? "No files waiting to be built."
            : `${fileRequests.length} waiting to be built`
        }
      />
      <div className="px-3 lg:px-6 py-6 max-w-4xl mx-auto">
        <Section
          title="File Requests"
          subtitle="Agents waiting on a file · click to tell them it's ready"
          emptyText="No files waiting to be built."
          buttonLabel="Mark Completed"
          deals={fileRequests}
          findAgent={findAgent}
          subjectFor={(deal) => subjectForDeal(deal, getClientName)}
          viewLinkFor={fileRequestLink}
          onOpen={handleComplete}
          scroll={false}
        />
      </div>
    </div>
  );
}
